import React, { useLayoutEffect, useRef, useState } from "react"

export default function ShowWhen({when, children, otherwise=null}) {
    return when ? children : otherwise
}


export function VisibleWhen({when, children, style, display='block', duration=250, animationDirection='down', removeOnHide=false}) {

    const boxRef = useRef(null);
    const timeout = useRef(null);
    const [visible, setVisible] = useState(when);

    function handleAnimation() {
        clearTimeout(timeout.current);
        const {current: box} = boxRef

        if(!box?.style) return;
        
        if(when) {
            setTimeout(() => {
                if(removeOnHide) setVisible(true);
                box.style.display = display;
                setTimeout(() => {
                    box.style.scale = '1';
                    box.style.opacity ='1';
                }, 50)
            }, duration)
            return;
        }
        
        box.style.scale = animationDirection === 'up' ? '1.1' : '0.9';
        box.style.opacity ='0';

        timeout.current = setTimeout(() => {
            box.style.display = 'none';
            if(removeOnHide) setVisible(false);
        }, duration + 50)
    }

    useLayoutEffect(() => {
        handleAnimation();

        return () => {
            clearTimeout(timeout.current);
        }
    }, [when])

    return (
        <div ref={boxRef} style={{ ...style, transition: `all ${duration}ms`, opacity: '0', scale: '0.9'}} >
            {removeOnHide ? (
                visible ? children : null
            ) : children}
        </div>
    )
}



export function ShowWhenWithAnimation({when, children, style = {}, display='block', duration=500, otherwise=null, containerStyle={}, removeOnHide=false}) {
    return (
        <div style={{ ...containerStyle, position: 'relative'}} >
            <VisibleWhen 
                when={when} 
                children={children} 
                display={display} 
                duration={duration} 
                style={style}
                animationDirection={'up'} 
                removeOnHide={removeOnHide}
            />

            <VisibleWhen 
                when={!when} 
                children={otherwise} 
                display={display} 
                duration={duration} 
                style={style}
                animationDirection={'down'} 
                removeOnHide={removeOnHide}
            />
        </div>
    )
}